import { ActionIcon, Stack, Box, Title } from '@mantine/core';
import React from 'react';
import { primaryColor } from '../../constants/theme';

interface ActionTileProps {
  icon: React.ReactNode;
  title: string;
  onClick: () => void;
  testId?: string;
}

export const ActionTile = ({
  icon,
  title,
  onClick,
  testId,
}: ActionTileProps) => {
  return (
    <ActionIcon
      size={50}
      w={100}
      h={100}
      variant="outline"
      color={primaryColor}
      onClick={onClick}
      data-testid={testId}
    >
      <Stack gap={0} h="100%" w="100%">
        <Box
          h="50%"
          display="flex"
          style={{ alignItems: 'center', justifyContent: 'center' }}
        >
          {icon}
        </Box>
        <Box
          h="50%"
          display="flex"
          p={2}
          style={{ alignItems: 'center', justifyContent: 'center' }}
        >
          <Title order={6} ta="center" size="xs">
            {title}
          </Title>
        </Box>
      </Stack>
    </ActionIcon>
  );
};
